"use strict";

import angular from "angular";

import template from "./metric-kpi-visualization.component.html";
import "./metric-kpi-visualization.component.scss";

import { ColorService } from "../../../presentation/services/ColorService/ColorService";

class MetricKpiVisualizationComponent {
    skeleton = true;
    constructor(ThemesService, $element, $scope) {
        this.$element = $element;
        this.$scope = $scope;
        this.ColorService = new ColorService({ ThemesService: ThemesService });
    }

    $onInit() {
        this.onViewInit();
    }

    onViewInit() {
        this.skeleton = true;
        const colorPath =
            this.visualizationData?.component?.configs?.series?.[0].color ||
            "basic.dark";
        const color = this.ColorService.colorByPath(colorPath);
        setTimeout(() => {
            const indicatorValueEl = this.$element[0].getElementsByClassName(
                "indicator-value"
            );
            if (indicatorValueEl?.[0]?.style)
                indicatorValueEl[0].style.color = color;
            this.skeleton = false;
            this.$scope.$applyAsync();
        }, 2000);
    }

    $onChanges(changes) {}
}

MetricKpiVisualizationComponent.$inject = [
    "ThemesService",
    "$element",
    "$scope"
];

const name = "metricKpiVisualizationComponent";
const def = {
    bindings: {
        series: "<",
        configs: "<",
        points: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        historicSeries: "<",
        projection: "<",
        budget: "<",
        goals: "<",
        visualizationData: "<",
        currentFilterGroup: "<",
        companyData: "<",
        isAccumulated: "<"
    },
    controller: MetricKpiVisualizationComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
